// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"202":"matka-details","253":"wallet-deposit","345":"deposit-payment-method","356":"sports","490":"add-account","535":"login","812":"sport-event-detail"}[chunkId] + "." + {"202":"8504646f","253":"ba8e0770","345":"a40573fc","356":"d52156c3","490":"dddb3057","535":"fb873a34","812":"2c2baa16"}[chunkId] + ".css";
};